<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">攤位活動</a>
          <span>/</span>修改活動
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <h1>修改攤位活動</h1>
          <p class="my-3">&nbsp;</p>

          <div>
            <div class="alert">
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                貴單位建立之活動內容，應遵守中華民國或展覽當地相關法令，並不得有違反善良風俗、色情、暴力、賭博、侵權或涉及任何不法行為。
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                主辦單位僅提供平台，不對各攤位活動的內容、品質或合法性負任何擔保責任。
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                若發現任何不當行為，主辦單位保留中止該活動或取消參展資格的權利。
              </div>
            </div>
          </div>
        </div>
        <p class="my-3">&nbsp;</p>

        <form
          name="_method"
          id="form"
          enctype="multipart/form-data"
          @submit.prevent="AddNewEvent"
        >
          <input type="hidden" name="RegNo" value="" />
          <!-- left -->
          <!-- PC版圖片顯示 -->

          <!-- PC版圖片顯示 -->

          <div class="proLeft PcDevice">
            <label class="inputFile">
              <div class="squareThumb pointer ImgHoverStyle">
                <img :src="modelSrc" class="img-fluid" />
              </div>

              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".JPG"
                @change="uploadNewImgPC($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">選擇圖片</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >重設圖片
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">檔案大小：最大 3MB</p>
              <p class="italic">檔案限制：JPG</p>
              <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
            </div>
          </div>

          <!-- 行動版圖片顯示 -->

          <div class="proLeft MbDevice">
            <label class="inputFile pointer">
              <div class="mb-3">
                <img :src="modelSrc" class="img-fluid" />
              </div>
              <p class="my-3">&nbsp;</p>
              <span name="showName" class="nowrap"></span>
              <input
                type="file"
                name="ProImg"
                accept=".JPG"
                @change="uploadNewImgMb($event)"
              />
              <p class="divider"></p>
              <div class="d-flex justify-content-around">
                <div>
                  <p class="align_c">
                    <span class="btnStyle btnGray">選擇圖片</span>
                  </p>
                </div>
                <div v-if="modelSrc !== OImgSrc">
                  <p class="align_c">
                    <span class="btnStyle btnRed" @click.prevent="resetImg"
                      >重設圖片
                    </span>
                  </p>
                </div>
              </div>
            </label>
            <div class="uploadAlert">
              <p class="italic">檔案大小：最大 3MB</p>
              <p class="italic">檔案限制：JPG</p>
              <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
            </div>
          </div>

          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div>
              <p class="formTitle">官網狀態</p>
              <div class="form-check-inline">
                <div class="formstatus">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="yes"
                    :value="true"
                    v-model="EventArchive"
                  />
                  <label class="form-check-label" for="yes"> 顯示</label>
                </div>
                <div class="ml-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="no"
                    :value="false"
                    v-model="EventArchive"
                  />
                  <label class="form-check-label" for="no"> 隱藏 </label>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">活動名稱 <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="EventName"
                  class="textStyle maxText"
                  maxlength="50"
                  required
                  placeholder="中文"
                  v-model="EventName"
                />
                <span>中</span>
              </div>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">活動時間 <span class="red">*</span></p>
              <div v-if="EventDatesList[0]" class="d-flex align-items-center">
                <!-- 勾選：啟用這天 -->
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day1-check'"
                    v-model="day1.enabled"
                  />
                  <label class="form-check-label" :for="'day1-check'">
                    {{ EventDatesList[0] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>開始時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day1.startTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day1.enabled"
                    :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">結束時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day1.endTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day1.enabled"
                    :class="{ 'is-invalid': day1.enabled && !isDay1Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[1]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day2-check'"
                    v-model="day2.enabled"
                  />
                  <label class="form-check-label" :for="'day2-check'">
                    {{ EventDatesList[1] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>開始時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day2.startTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day2.enabled"
                    :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">結束時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day2.endTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day2.enabled"
                    :class="{ 'is-invalid': day2.enabled && !isDay2Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[2]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day3-check'"
                    v-model="day3.enabled"
                  />
                  <label class="form-check-label" :for="'day3-check'">
                    {{ EventDatesList[2] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>開始時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day3.startTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day3.enabled"
                    :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">結束時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day3.endTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day3.enabled"
                    :class="{ 'is-invalid': day3.enabled && !isDay3Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[3]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day4-check'"
                    v-model="day4.enabled"
                  />
                  <label class="form-check-label" :for="'day4-check'">
                    {{ EventDatesList[3] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>開始時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day4.startTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day4.enabled"
                    :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">結束時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day4.endTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day4.enabled"
                    :class="{ 'is-invalid': day4.enabled && !isDay4Valid }"
                  ></vue-timepicker>
                </div>
              </div>
              <div v-if="EventDatesList[4]" class="d-flex align-items-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'day5-check'"
                    v-model="day5.enabled"
                  />
                  <label class="form-check-label" :for="'day5-check'">
                    {{ EventDatesList[4] }}
                  </label>
                </div>

                <div class="d-flex align-items-center ml-2">
                  <div>開始時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day5.startTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day5.enabled"
                    :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                  ></vue-timepicker>

                  <div class="ml-2">結束時間：</div>
                  <vue-timepicker
                    :minute-interval="10"
                    v-model="day5.endTime"
                    format="HH:mm"
                    placeholder="時 : 分"
                    :disabled="!day5.enabled"
                    :class="{ 'is-invalid': day5.enabled && !isDay5Valid }"
                  ></vue-timepicker>
                </div>
              </div>

              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">活動說明 <span class="red">*</span></p>
              <textarea
                name="EventDesc"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="EventDesc"
                maxlength="200"
                required
              ></textarea>
              <p class="grayBG">字數限制 200 字元</p>

              <p class="my-3">&nbsp;</p>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">活動警語</p>
              <textarea
                name="ProWarning"
                rows="4"
                class="maxText textStyle"
                placeholder=""
                v-model="EventRemind"
                maxlength="200"
              ></textarea>

              <p class="grayBG">字數限制 200 字元</p>

              <p class="my-3">&nbsp;</p>
            </div>
          </div>
          <!-- right end -->
          <p class="clear"></p>
          <p class="PcDevice my-4">&nbsp;</p>
          <div class="text-center PcDevice mb-4">
            <button class="btn btn-lg btn-primary mr-4" type="submit">
              確認送出
            </button>
            <button
              class="btn btn-lg btn-secondary"
              @click.prevent="backEventPage"
            >
              返回
            </button>
          </div>

          <div class="text-center mb-4 MbDevice">
            <button class="btn btn-primary mr-2" type="submit">確認送出</button>
            <button class="btn btn-secondary" @click.prevent="backEventPage">
              返回
            </button>
          </div>
        </form>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <div class="modal-title" style="font-size: 25px">
                  <div class="d-flex align-self-center">
                    <div class="mr-3">
                      <img
                        src="../../../assets/images/cropImg.png"
                        width="30px"
                      />
                    </div>
                    <div style="font-size: 25px">編輯活動圖片</div>
                  </div>
                </div>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          向左旋轉
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          向右旋轉
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          放大
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          縮小
                        </button>
                      </div>
                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          重設
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="ImgPreCrop">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-primary btn-lg mr-2"
                    @click="OutputPC()"
                  >
                    裁切
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>&middot; 系統將自動調整圖片至正方形尺寸。</p>
                <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputMb()"
                >
                  確定
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "攤位活動 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      EventID: "",
      currentPage: 1,

      UserId: "",
      showImg: false,
      CSRF_Token: "",
      RegNo: "",
      EventArchive: true,
      EventName: "",
      EventDesc: "", //活動說明
      modelSrc: "",
      OImgSrc: "", // 原始圖片

      previews: {},
      previewStyle1: {},
      lang: "tw",

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: false, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: false, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: false, // 上传图片按照原始比例渲染

        size: 0.7, //裁剪生成图片的质量V
        outputType: "png", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      LocalExh: true,
      EventDatesList: [],

      // 你原本的
      day1: { enabled: false, startTime: "", endTime: "" },
      day2: { enabled: false, startTime: "", endTime: "" },
      day3: { enabled: false, startTime: "", endTime: "" },
      day4: { enabled: false, startTime: "", endTime: "" },
      day5: { enabled: false, startTime: "", endTime: "" },

      EventDatesRaw: [],

      EventRemind: "",
      BoothEventTime: [],
    };
  },

  computed: {
    // 基本驗證：若啟用，需有 start/end 且 start < end
    isDay1Valid() {
      if (!this.day1.enabled) return true;
      if (!this.day1.startTime || !this.day1.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day1.startTime) < toMin(this.day1.endTime);
    },
    isDay2Valid() {
      if (!this.day2.enabled) return true;
      if (!this.day2.startTime || !this.day2.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day2.startTime) < toMin(this.day2.endTime);
    },
    isDay3Valid() {
      if (!this.day3.enabled) return true;
      if (!this.day3.startTime || !this.day3.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day3.startTime) < toMin(this.day3.endTime);
    },
    isDay4Valid() {
      if (!this.day4.enabled) return true;
      if (!this.day4.startTime || !this.day4.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day4.startTime) < toMin(this.day4.endTime);
    },

    isDay5Valid() {
      if (!this.day5.enabled) return true;
      if (!this.day5.startTime || !this.day5.endTime) return false;
      // 'HH:mm' 直接字串比較也可行，保險起見轉分鐘比較
      const toMin = (t) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
      };
      return toMin(this.day5.startTime) < toMin(this.day5.endTime);
    },

    TimesForApi() {
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      const result = [];

      days.forEach((d, idx) => {
        const date = this.EventDatesRaw?.[idx]; // YYYY/MM/DD
        if (!date) return; // 沒有日期就跳過

        const hasTime = d.startTime || d.endTime;

        // 規則：勾選的要存；或沒勾選但有填時間也要存
        if (d.enabled || hasTime) {
          result.push({
            Date: date,
            StartTime: d.startTime || "",
            EndTime: d.endTime || "",
            Enable: !!d.enabled,
          });
        }
      });

      return result;
    },

    hasAnyDayChecked() {
      // 判斷是否有至少一天「勾選」且「有填開始/結束時間」
      const days = [this.day1, this.day2, this.day3, this.day4, this.day5];
      return days.some((day) => {
        return day.enabled && day.startTime && day.endTime;
      });
    },
  },

  methods: {
    resetImg() {
      const vm = this;
      vm.modelSrc = vm.OImgSrc;
    },

    AddNewEvent() {
      const vm = this;

      if (vm.hasAnyDayChecked) {
        const url = "/apiExhibitors/BoothEvent/";

        const isUnchangedPic =
          (vm.modelSrc || "").trim() === (vm.initialLogo || "").trim();

        const info = {
          RegNo: vm.RegNo,
          BoothEventID: vm.EventID,
          IsShow: vm.EventArchive,

          EventPic: isUnchangedPic ? "" : vm.modelSrc,
          BoothEventName: vm.EventName,
          BoothEventEName: "",
          BoothEventDesc: vm.EventDesc,
          BoothEventEDesc: "",
          BoothEventRemind: vm.EventRemind,
          BoothEventERemind: "",
          Times: vm.TimesForApi,
          CSRF: vm.CSRF_Token,
        };

        if (vm.modelSrc == "../../../assets/images/default.jpg") {
          alert("圖片為必填項目，請重新檢查！");
        } else {
          if (!vm.EventName || !vm.EventDesc) {
            alert("輸入欄位不完整，請重新檢查！");
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert("您已成功修改攤位活動！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
              } else if (
                response.data.Code == 251 ||
                response.data.Code == 500
              ) {
                alert("系統忙碌，請稍後再試！");
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`;
              } else if (response.data.Code == 253) {
                alert("圖片檔案上傳錯誤！");
              } else if (response.data.Code == 401) {
                alert("請檢查欄位，並注意結束時間不可早於或等於開始時間！");
              }
            });
          }
        }
      } else {
        alert("請至少勾選一天，並填寫完整的開始與結束時間！");
      }
    },

    uploadNewImgPC(e) {
      const vm = this;

      let file = e.target.files[0];

      if (!/\.(jpg|jpeg|JPG|JPEG)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG！");
        return false;
      }

      let reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        // console.log(e)
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result])
            );
          });
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG！");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result])
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };
      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });

        window.setTimeout(
          () =>
            alert(
              "恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改活動之程序。"
            ),
          1000
        );
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;

      window.setTimeout(
        () =>
          alert(
            "恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改活動之程序。"
          ),
        1000
      );
    },

    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    backEventPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.EventID = currentUrl.split("id=")[1].split("&")[0];

    if (currentUrl.split("Page=")[1]) {
      vm.currentPage = currentUrl.split("Page=")[1];
    }

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("系統忙線中，請稍後再試");
        }
      });

    let url = `/apiExhibitors/BoothEvent/Info/${vm.RegNo}?BoothEventID=${vm.EventID}`;
    axios
      .get(url)
      .then(function (response) {
        console.log(response);
        if (response.data.Data) {
          vm.BoothEventTime = response.data.Data.BoothEventTime;
          vm.EventArchive = response.data.Data.IsShow;
          vm.EventName = response.data.Data.BoothEventName;
          vm.EventDesc = response.data.Data.BoothEventDesc;
          vm.EventRemind = response.data.Data.BoothEventRemind;

          vm.modelSrc = `${response.data.Data.EventPic}`;

          vm.OImgSrc = `${response.data.Data.EventPic}`;
          vm.initialLogo = `${response.data.Data.EventPic}`;

          // ========= B. 前台用日期列表 EventDatesList / API 用 EventDatesRaw =========
          const weekMap = ["日", "一", "二", "三", "四", "五", "六"];
          const showDates = [];
          const rawDates = [];

          const beginStr = response.data.Data.ExhBegin; // 可能是 "2025/11/19" 或 ISO
          const endStr = response.data.Data.ExhEnd;

          if (beginStr && endStr) {
            const begin = new Date(beginStr);
            const end = new Date(endStr);
            // 生出展期間連續日期
            for (
              let d = new Date(begin);
              d <= end;
              d.setDate(d.getDate() + 1)
            ) {
              const y = d.getFullYear();
              const m = String(d.getMonth() + 1).padStart(2, "0");
              const dd = String(d.getDate()).padStart(2, "0");
              const w = weekMap[d.getDay()];
              showDates.push(`${m}/${dd}(${w})`); // 顯示用
              rawDates.push(`${y}/${m}/${dd}`); // 給 API 用
            }
          } else if (vm.BoothEventTime.length) {
            // 沒展期，用 BoothEventTime 補：BoothEventTime.Date 是 "MM/DD"
            const thisYear = new Date().getFullYear(); // 或改成你的活動年
            vm.BoothEventTime.forEach((it) => {
              const [m, d] = (it.Date || "").split("/");
              if (!(m && d)) return;
              const ymd = `${thisYear}/${String(m).padStart(2, "0")}/${String(
                d
              ).padStart(2, "0")}`;
              const dObj = new Date(ymd);
              const w = isNaN(dObj) ? "" : `(${weekMap[dObj.getDay()]})`;
              showDates.push(
                `${String(m).padStart(2, "0")}/${String(d).padStart(
                  2,
                  "0"
                )}${w}`
              );
              rawDates.push(ymd);
            });
          }

          vm.EventDatesList = showDates;
          vm.EventDatesRaw = rawDates;

          // ========= C. 回填 BoothEventTime -> day1~day5 =========
          const clean = (t) => (!t || t === "00:00" ? "" : t);
          const toMMDD = (s) => {
            const p = (s || "").split("/");
            return p.length === 3
              ? `${p[1].padStart(2, "0")}/${p[2].padStart(2, "0")}` // YYYY/MM/DD -> MM/DD
              : `${(p[0] || "").padStart(2, "0")}/${(p[1] || "").padStart(
                  2,
                  "0"
                )}`; // MM/DD
          };

          // 以 MM/DD 當 key 做快查
          const byMMDD = new Map();
          vm.BoothEventTime.forEach((it) => {
            byMMDD.set(toMMDD(it.Date), {
              startTime: clean(it.StartTime),
              endTime: clean(it.EndTime),
              enabled: !!it.Enable,
            });
          });

          const days = [vm.day1, vm.day2, vm.day3, vm.day4, vm.day5];

          days.forEach((dayObj, idx) => {
            const rawDate = vm.EventDatesRaw?.[idx]; // "YYYY/MM/DD"
            if (!rawDate) return;
            const key = toMMDD(rawDate); // "MM/DD"

            const found = byMMDD.get(key);
            if (found) {
              dayObj.startTime = found.startTime; // "00:00" 轉 ""
              dayObj.endTime = found.endTime;
              dayObj.enabled = found.enabled; // 未勾選但有時間也會回填到欄位
            } else {
              dayObj.startTime = "";
              dayObj.endTime = "";
              dayObj.enabled = false;
            }
          });
        } else {
          alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
        }
      })
      .catch((err) => {
        alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
      });
  },
};
</script>

<style lang="scss">
.form-control {
  height: calc(2.2em + 0.75rem + 2px);
}

// @media screen and (min-width: 331px) and (max-width: 576px) {
//   .modal-content {
//     width: 65%;
//   }
// }

// @media screen and (max-width: 330px) {
//   .modal-content {
//     width: 60%;
//   }
// }

.modal-xl {
  max-width: 940px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.custom-control-label {
  font-size: 15px;
}

.el-collapse-item__header {
  font-size: 17px;
  font-weight: 550;
}

.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 70px !important;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;

  /* 你要的修改 */
  border-radius: 3px; /* 圓潤度調高 */
  margin-bottom: 3px; /* mb-2 的效果 (大概 0.5rem ≈ 8px) */
}

.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 70px !important;
  font-family: sans-serif;
  vertical-align: middle;
}

.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}
</style>
